import { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { type LoaderFunctionArgs } from 'react-router'
import MarketingSpacer from '#app/components/marketing/spacer.js'
import { Separator } from '#app/components/ui/separator.js'
import { usePublicContext } from '#app/routes/($lang)+/__public-context.tsx'
import { BASE_URL } from '#app/utils/config.js'
import { generateMetaTranslationLoader } from '#app/utils/i18next.server.js'
import { generateTranslatedMeta } from '#app/utils/meta.js'
import routes from '#routes/index.tsx'
import {
	LegalContainer,
	LegalHeading1,
	LegalHeading2,
	LegalListItem,
	LegalParagraph,
	LegalSection,
	LegalSubtitle,
	LegalUnorderedList,
} from './__utils.tsx'

export async function loader({ request }: LoaderFunctionArgs) {
	return {
		meta: await generateMetaTranslationLoader({
			request,
			keys: {
				title: 'privacy.title',
				description: 'privacy.description',
				canonical: `${BASE_URL}${routes.public.legal.privacy.route({})}`,
			},
		}),
	}
}

export const meta = generateTranslatedMeta

export default function Cookies() {
	const { t } = useTranslation('legal')

	const {
		navigation: { route },
	} = usePublicContext()

	useEffect(() => {
		route.setContent([
			{
				label: `${t('privacy.title')}.`,
			},
		])
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<LegalContainer>
			<MarketingSpacer side="top" />
			<LegalSection>
				<div>
					<LegalHeading1>{t('privacy.title')}</LegalHeading1>
					<LegalSubtitle>{t('privacy.description')}</LegalSubtitle>
				</div>
			</LegalSection>

			<Separator />

			<LegalSection>
				<LegalParagraph>{t('privacy.compliance.1')}</LegalParagraph>
				<LegalParagraph>{t('privacy.compliance.2')}</LegalParagraph>
			</LegalSection>

			<Separator />

			<LegalSection>
				<LegalHeading2>{t('privacy.dpo.title')}</LegalHeading2>

				<LegalUnorderedList>
					<LegalListItem>
						<Trans>{t('privacy.dpo.1')}</Trans>
					</LegalListItem>
					<LegalListItem>
						<Trans>{t('privacy.dpo.2')}</Trans>
					</LegalListItem>
					<LegalListItem>
						<Trans>{t('privacy.dpo.3')}</Trans>
					</LegalListItem>
					<LegalListItem>
						<Trans>{t('privacy.dpo.4')}</Trans>
					</LegalListItem>
					<LegalListItem>
						<Trans>{t('privacy.dpo.5')}</Trans>
					</LegalListItem>
					<LegalListItem>
						<Trans>{t('privacy.dpo.6')}</Trans>
					</LegalListItem>
					<LegalListItem>
						<Trans>{t('privacy.dpo.7')}</Trans>
					</LegalListItem>
				</LegalUnorderedList>
			</LegalSection>

			<Separator />

			<LegalSection>
				<LegalParagraph>{t('privacy.what&how.pre')}</LegalParagraph>
			</LegalSection>
			<Separator />

			<LegalSection>
				<LegalHeading2>{t('privacy.what&how.1.title')}</LegalHeading2>

				<LegalParagraph>{t('privacy.what&how.1.description')}</LegalParagraph>
			</LegalSection>

			<Separator />

			<LegalSection>
				<LegalHeading2>{t('privacy.what&how.2.title')}</LegalHeading2>

				<LegalParagraph>{t('privacy.what&how.2.description')}</LegalParagraph>
			</LegalSection>

			<Separator />

			<LegalSection>
				<LegalHeading2>{t('privacy.what&how.3.title')}</LegalHeading2>

				<LegalParagraph>{t('privacy.what&how.3.description')}</LegalParagraph>
			</LegalSection>

			<Separator />

			<LegalSection>
				<LegalHeading2>{t('privacy.what&how.4.title')}</LegalHeading2>

				<LegalParagraph>{t('privacy.what&how.4.description')}</LegalParagraph>
			</LegalSection>

			<Separator />

			<LegalSection>
				<LegalHeading2>{t('privacy.what&how.5.title')}</LegalHeading2>

				<LegalParagraph>{t('privacy.what&how.5.description')}</LegalParagraph>
			</LegalSection>

			<Separator />

			<LegalSection>
				<LegalParagraph className={'font-semibold'}>
					{t('privacy.automated.title')}
				</LegalParagraph>

				<LegalParagraph>{t('privacy.automated.description')}</LegalParagraph>

				<LegalParagraph className={'font-semibold'}>
					{t('privacy.transfers.abroad.title')}
				</LegalParagraph>

				<LegalParagraph>
					{t('privacy.transfers.abroad.description')}
				</LegalParagraph>
			</LegalSection>

			<MarketingSpacer side="bottom" />
		</LegalContainer>
	)
}
